import { IBaseEntity, IBaseQuery } from './common.type';

export interface IFileBrowserFile {
  type: 'directory' | 'file';
  path: string;
  basename: string;
  size?: number;
  mode?: number | null;
  lastModified: string;
  tree_path: string;
  parentId: string;
  children?: IFileBrowserFile[];
}

export interface ICloud extends IBaseEntity {
  title: string;
  note?: string;
  time: number;
  parent_id?: string;
  type: number;
  file_url?: string;
  text_to_speech?: string;
  speech_type?: string;
  link?: string;
  size?: number;
  extension?: string;
  tree_path?: string;
  order?: number;
  url_temp?: string;
  parent?: ICloud;
  children?: ICloud[];
  path_name?: string;
}

export enum ContentType {
  FOLDER,
  LIST,
  LINK,
  TTS,
  FILE,
}

export interface ICloudQuery extends IBaseQuery {
  // areas_path?: string;
  parentId?: string;
  type?: ContentType;
}

export interface IBreadcrumPath {
  title: string | JSX.Element | React.ReactNode;
  id: string;
  // isArea?: boolean;
  isSearch?: boolean;
  isPersonal?: boolean;
}

export interface ICloudBody {
  id?: string;
  title?: string;
  note?: string;
  parentId?: string;
  order?: number;
}

export interface IUploadFileBody extends ICloudBody {
  files: File[];
  // titles: string[];
}

export interface ILinkBody extends ICloudBody {
  link: string;
  time?: number;
  temp_link?: string;
  // url?: string;
}

export interface IEditListBody {
  id?: string;
  note?: string;
  title: string;
  itemIds: string[];
}

export interface IBodyRename {
  title: string;
}

export interface ICreateListBody extends ICloudBody {
  files?: File[];
  tts?: File[];
  fileInfo?: ICreateListItemBody[];
  linkInfo?: ICreateListItemBody[];
  ttsInfo?: ICreateListItemBody[];
  ttsUploadInfo?: ICreateListItemBody[];
}
export interface IUpdateListBody extends ICreateListBody {
  deleteIds?: string[];
  contentUpdates?: IListItemBody[];
}
export interface ICreateListItemBody {
  title: string;
  order: number;
  link?: string | null;
  time?: number;
  url?: string | null;
  text_to_speech?: string;
}
export interface IListItemBody {
  title: string;
  order: number;
  time?: number;
  id: string;
}
export interface ITextBody extends ICloudBody {
  file?: File;
  url?: string | null;
  text_to_speech?: string;
}
